import { z as zod } from 'zod'

import { DefaultSchemas } from './defaultSchemas'

export const Report17DataSchemas = zod.object({
    salesCentre: zod.string(),
    salesCentreUser: zod.string().nullable(),
    ident: zod.string().nullable(),
    transactionDate: zod.string().nullable(),
    giftCardSalesSum: zod.number().nullable(),
    serviceFees: zod.number().nullable(),
    cardCarrier: zod.number().nullable(),
    customGiftCardFees: zod.number().nullable(),
    seasonalGiftCardFees: zod.number().nullable(),
    courier: zod.number().nullable(),
    administrationFees: zod.number().nullable(),
    busTickets: zod.number().nullable(),
    carparks: zod.number().nullable(),
    kiddyCruisers: zod.number().nullable(),
    totalSum: zod.number().nullable(),
    tenderCashSum: zod.number().nullable(),
    tenderEftposSum: zod.number().nullable(),
    tenderVisaSum: zod.number().nullable(),
    tenderMcardSum: zod.number().nullable(),
    tenderAmexSum: zod.number().nullable(),
    tenderDinersSum: zod.number().nullable(),
    tenderGiftCardSum: zod.number().nullable(),
    tenderDirectCreditSum: zod.number().nullable(),
    tenderAllSum: zod.number().nullable(),
    orderColumn: zod.number().nullable(),
})

export const Report17CSVDataSchemas = zod.object({
    salesCentre: zod.string(),
    salesCentreUser: zod.string().nullable(),
    ident: zod.string().nullable(),
    transactionDate: zod.string().nullable(),
    giftCardSalesSum: zod.number().nullable(),
    serviceFees: zod.number().nullable(),
    cardCarrier: zod.number().nullable(),
    customGiftCardFees: zod.number().nullable(),
    seasonalGiftCardFees: zod.number().nullable(),
    courier: zod.number().nullable(),
    administrationFees: zod.number().nullable(),
    busTickets: zod.number().nullable(),
    carparks: zod.number().nullable(),
    kiddyCruisers: zod.number().nullable(),
    totalSum: zod.number().nullable(),
    tenderCashSum: zod.number().nullable(),
    tenderEftposSum: zod.number().nullable(),
    tenderVisaSum: zod.number().nullable(),
    tenderMcardSum: zod.number().nullable(),
    tenderAmexSum: zod.number().nullable(),
    tenderDinersSum: zod.number().nullable(),
    tenderGiftCardSum: zod.number().nullable(),
    tenderDirectCreditSum: zod.number().nullable(),
    tenderAllSum: zod.number().nullable(),
    orderColumn: zod.number().nullable(),
})

export const Report17CreateFormSchemas = zod.object({
    startDate: zod.string().min(1, { message: 'Start date is Required.' }),
    endDate: zod.string().min(1, { message: 'End date is Required.' }),
    test: zod.number(),
    fromTraderId: zod.number().nullable().optional(),
    reportTypeId: zod.number(),
})

export const Report17APISchemas = DefaultSchemas.merge(
    zod.object({
        data: Report17DataSchemas.array()
    })
)

export type Report17CreateFormTypes = zod.infer<typeof Report17CreateFormSchemas>;
export type Report17DataTypes = zod.infer<typeof Report17DataSchemas>;
export type Report17CSVDataTypes = zod.infer<typeof Report17CSVDataSchemas>;    
export type Report17APITypes = zod.infer<typeof Report17APISchemas>;